import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { Animate, AnimateKeyframes, AnimateGroup } from 'react-simple-animate';
import moment from 'moment';

export default class Tradeplate extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: true,
            data: props.data || null,
        };
    }

    render() {

        let startDate = (this.state.data.start_date != null) ? moment(this.state.data.start_date).format("YYYY-MM-DD") : "";
        let endDate = (this.state.data.end_date != null) ? moment(this.state.data.end_date).format("YYYY-MM-DD") : "";
        return (
                <div className="row">
                    <div className="col-md-2">
                        {this.state.data.description}
                    </div>
                    <div className="col-md-1" title="reference">
                        {this.state.data.insurance_reference}
                    </div>
                    <div className="col-md-2">
                        &pound;{this.state.data.amount_paid} / &pound;{this.state.data.original_amount_to_repay}
                    </div>
                    <div className="col-md-2">
                        &pound;{this.state.data.agreed_deduction_amount} {this.state.data.deduction_occurance}
                    </div>
                    <div className="col-md-1">
                        <button className="btn btn-sm btn-default">Details</button>
                    </div>
                    <div className="col-md-2">{startDate}</div>
                    <div className="col-md-2">{endDate}</div>
                </div>
                );
    }

}
